import React from "react";
import * as mobx from 'mobx';
import SysFavouriteItem from "./SysFavouriteItem";

export default class SysFavouriteList extends React.Component {
    renderItems() {
        let list = mobx.toJS(this.props.data);
        let {
            favouriteDialogStore, favouriteBrowserStore, sysFavouriteStore, favouriteDirStore, myFavouriteStore, sysFavFormStore,
            repeatIconTitle, editIconTitle, moveIconTitle, deleteIconTitle, favTypeMap, selectedIds
        } = this.props;
        return list.map(item => {
            let props = {
                ...item,
                favouriteDialogStore,
                favouriteBrowserStore,
                sysFavouriteStore,
                favouriteDirStore,
                myFavouriteStore,
                sysFavFormStore,
                repeatIconTitle,
                editIconTitle,
                moveIconTitle,
                deleteIconTitle,
                favTypeMap,
                selectedIds
            };
            return <SysFavouriteItem key={item.favid} {...props}/>;
        });
    }


    render() {
        const items = this.renderItems();
        return (
            <div className="sysfav-list">
                {items}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/favourite/SysFavouriteList.js